module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.model.children.length > 0) ? _c('el-submenu', {
    attrs: {
      "index": _vm.model.path
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    class: _vm.model.icon
  }), _vm._v(_vm._s(_vm.model.title))]), _vm._v(" "), _vm._l((_vm.model.children), function(cl, index) {
    return _c('menuitems', {
      key: index,
      attrs: {
        "model": cl
      }
    })
  })], 2) : (_vm.model.children.length == 0) ? _c('el-menu-item', {
    attrs: {
      "index": _vm.model.path
    }
  }, [_c('i', {
    class: _vm.model.icon
  }), _vm._v(_vm._s(_vm.model.title))]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-51a47a3d"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuItems.vue
// module id = 238
// module chunks = 1